import * as React from "react";

function SvgSlant2(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="slant-2_svg__st1" d="M1610 39.2V209H-10V39.2l810 118.9 810-118.9z" /></svg>;
}

export default SvgSlant2;